import { Avatar, Stack, Typography } from "@mui/material";
import InlineTags from "@entrilia/shared/components/InlineTags";
import EntriliaMarkIcon from "@entrilia/shared/icons/EntriliaMarkIcon";
import { getCategoryColorFromNameHash } from "@entrilia/shared/utilities/categoryColor";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import { isDefined } from "@entrilia/shared/utilities/typeHelper";
import type { VideoLibraryCategory, VideoLibraryItem } from "../../../api/types/videoLibraryTypes";

interface Props {
  videoInfo: VideoLibraryItem;
  allCategories: VideoLibraryCategory[];
}

const VideoInfoSection = ({ videoInfo, allCategories }: Props) => {
  const categories = videoInfo.categoryIds
    .map((categoryId) => allCategories.find((category) => category.id === categoryId))
    .filter(isDefined<VideoLibraryCategory>());

  return (
    <Stack spacing={1.5} sx={{ width: "100%" }}>
      <Typography variant="h5">{videoInfo.name}</Typography>
      <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <Avatar sx={{ bgcolor: "primary.main", width: 24, height: 24 }}>
            <EntriliaMarkIcon sx={{ color: "common.white", width: 16, height: 16 }} />
          </Avatar>
          <Typography>Entrilia</Typography>
        </Stack>
        <Typography color="textSecondary">{convertISODateTime(videoInfo.uploadedAt)}</Typography>
      </Stack>
      <InlineTags tags={categories.map((c) => ({ label: c.name, color: getCategoryColorFromNameHash(c.name) }))} />
      <Typography>{videoInfo.description}</Typography>
    </Stack>
  );
};

export default VideoInfoSection;
